import React, { useContext, useEffect, useState } from 'react'
import { Badge } from '@/components/ui/badge'
import { TransactionAdjustmentUploadHistory } from 'api/Wallet/Types/TransactionAdjustmentUploadHistory'
import {
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Loading } from 'components/Loading'
import { successToast, ToastContext } from 'components/Toast/Toast'
import styled from 'styled-components'
import { useApiClient } from 'utils/api/ApiClient'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

import { FormFieldLabel, SectionBlock } from '../Transactions.styles'
import { UploadTransactionHistoryTable } from '../UploadTransactionHistoryTable'

interface Props {
  historyUploadId: string
  onClose(): void
}

export const Container = styled.section`
  margin: 2.5em;
`

export const TransactionUploadHistoryPage: React.FC<Props> = (props) => {
  const setToast = useContext(ToastContext)
  const walletsApiClient = useApiClient(WalletsApiClient)
  const [skipRefresh, setSkipRefresh] = useState(false)
  const [historyData, setHistoryData] = useState<TransactionAdjustmentUploadHistory | undefined>(
    undefined
  )

  useEffect(() => {
    if (skipRefresh) {
      return
    }
    const interval = setInterval(async () => {
      const response = await walletsApiClient.getTradingAccountAdjustmentHistoryUpload(
        props.historyUploadId
      )
      if (response.dateFinished) {
        setSkipRefresh(true)
        return setHistoryData(response)
      }
    }, 2000)
    return () => clearInterval(interval)
  }, [skipRefresh, props.historyUploadId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (historyData) {
      setToast(successToast('Transactions have been created.'))
    }
  }, [historyData, setToast])

  return (
    <Container>
      {!historyData && (
        <div style={{ height: '50vh' }}>
          <Badge>
            <Loading data-icon='inline-start' modalView isLoading={!historyData} />
            <span>Please wait upload in progress</span>
          </Badge>
        </div>
      )}
      {historyData && (
        <SectionBlock>
          <FormFieldLabel>Results</FormFieldLabel>

          <form>
            <FormBaseFieldBlock>
              <FormBaseRow>
                <FormBaseFieldLabel>Filename</FormBaseFieldLabel>
                <FormBaseFieldGroup>
                  <input type='text' disabled value={historyData?.fileName} />
                </FormBaseFieldGroup>
              </FormBaseRow>
            </FormBaseFieldBlock>
            <FormBaseFieldBlock>
              <FormBaseRow>
                <FormBaseFieldLabel>Date Created</FormBaseFieldLabel>
                <FormBaseFieldGroup>
                  <input type='text' disabled value={historyData?.dateCreated} />
                </FormBaseFieldGroup>
              </FormBaseRow>
            </FormBaseFieldBlock>
            <FormBaseFieldBlock>
              <FormBaseRow>
                <FormBaseFieldLabel>Date Finished</FormBaseFieldLabel>
                <FormBaseFieldGroup>
                  <input type='text' disabled value={historyData?.dateFinished || undefined} />
                </FormBaseFieldGroup>
              </FormBaseRow>
            </FormBaseFieldBlock>
          </form>
          {historyData && <UploadTransactionHistoryTable data={historyData} />}
        </SectionBlock>
      )}
    </Container>
  )
}
